{
  "appName": "VynaEMR",
  "appTagline": "APAC特化型電子カルテ",
  "developedByLabel": "開発",
  "loading": "読み込み中...",
  "save": "保存",
  "cancel": "キャンセル",
  "delete": "削除",
  "edit": "編集",
  "create": "新規作成",
  "search": "検索",
  "filter": "フィルター",
  "actions": "操作",
  "confirm": "確認",
  "back": "戻る",
  "next": "次へ",
  "previous": "前へ",
  "submit": "送信",
  "reset": "リセット",
  "close": "閉じる",
  "yes": "はい",
  "no": "いいえ",
  "ok": "OK",
  "error": "エラー",
  "success": "成功",
  "warning": "警告",
  "info": "お知らせ",
  "validation": {
    "required": "この項目は必須です",
    "invalidEmail": "メールアドレスの形式が正しくありません",
    "invalidPhone": "電話番号の形式が正しくありません",
    "invalidDate": "日付の形式が正しくありません",
    "minLength": "{{min}}文字以上で入力してください",
    "maxLength": "{{max}}文字以内で入力してください",
    "passwordMismatch": "パスワードが一致しません"
  },
  "form": {
    "fieldRequired": "{{field}}を入力してください",
    "selectOption": "項目を選択してください",
    "discardConfirm": "未保存の変更を破棄しますか？",
    "unsavedChanges": "未保存の変更があります",
    "mustBeNonNegativeInteger": "{{field}}は 0 以上の整数で入力してください",
    "mustBeNonNegativeNumber": "{{field}}は 0 以上の数値で入力してください"
  },
  "unsavedChanges": {
    "title": "未保存の変更",
    "body": "未保存の変更があります。本当にこのページを離れますか?変更内容は失われます。",
    "stay": "留まる",
    "leave": "離れる"
  },
  "messages": {
    "saveSuccess": "変更を保存しました",
    "saveError": "変更の保存に失敗しました",
    "deleteConfirm": "この項目を削除してもよろしいですか？",
    "deleteSuccess": "項目を削除しました",
    "deleteError": "項目の削除に失敗しました",
    "networkError": "ネットワークエラーが発生しました。接続を確認してください。",
    "serverError": "サーバーエラーが発生しました。しばらくしてから再度お試しください。",
    "unauthorized": "この操作を実行する権限がありません。"
  },
  "dateFormat": {
    "short": "YYYY/MM/DD",
    "long": "YYYY年M月D日",
    "withTime": "YYYY/MM/DD HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "これは VynaEMR のデモです — 実際の患者情報 (PHI) は入力しないでください。"
  },
  "network": {
    "offline": "オフラインです。臨床データが保存されない可能性があります。"
  },
  "permissionDenied": {
    "title": "アクセスが拒否されました",
    "body": "{{action}}する権限がありません。",
    "genericBody": "このリソースを表示する権限がありません。",
    "requiredPermission": "必要な権限：{{name}}",
    "contactAdmin": "これが誤りであると思われる場合は、システム管理者にお問い合わせください。",
    "requiresPermissionCode": "必要な権限：{{code}}",
    "requiresLabel": "{{label}}が必要です",
    "requiresLabelWithRoles": "{{label}}が必要です（保有者：{{roles}}）",
    "insufficient": "権限が不足しています"
  },
  "skipToContent": "メインコンテンツへスキップ",
  "openMenu": "メニューを開く",
  "topBar": {
    "searchPlaceholder": "患者を検索（MRN、氏名、ID）...",
    "recentPatients": "最近の患者",
    "searching": "検索中...",
    "noPatientsFound": "患者が見つかりません。Enter キーで検索してください。",
    "notifications": "通知",
    "selectFacility": "施設を選択",
    "allFacilities": "すべての施設",
    "facilityLabel": "施設 {{id}}",
    "activeDepartment": "勤務部門",
    "selectDepartment": "勤務部門を選択",
    "noDepartmentSelected": "部門を選択してください",
    "departmentLabel": "部門 {{id}}",
    "departmentSwitchFailed": "切り替えできませんでした"
  },
  "theme": {
    "toggle": "テーマを切り替え",
    "light": "ライト",
    "dark": "ダーク",
    "system": "システム",
    "current": "テーマ: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "稼働中",
  "footerHealthIssue": "接続の問題",
  "dobLabel": "生年月日 {{date}}",
  "pagination": {
    "previous": "前へ",
    "next": "次へ",
    "pageOf": "{{current}} / {{total}} ページ",
    "showing": "{{total}} 件中 {{from}} 〜 {{to}} 件を表示",
    "loadMore": "さらに表示"
  },
  "table": {
    "empty": "データがありません",
    "loading": "読み込み中..."
  },
  "cdsAlert": {
    "severity": {
      "info": "情報",
      "warning": "警告",
      "critical": "重大"
    },
    "overridden": "オーバーライド済み",
    "acknowledged": "確認済み",
    "justificationPlaceholder": "正当化理由を入力してください...",
    "submit": "送信",
    "acknowledge": "確認",
    "override": "オーバーライド",
    "regionAria": "臨床意思決定支援（CDS）アラート",
    "acknowledgeFailed": "確認を記録できませんでした — 保存されていません。もう一度お試しください。",
    "overrideFailed": "オーバーライドを記録できませんでした — 保存されていません。もう一度お試しください。",
    "addressedCount_one": "{{count}} 件対応済み",
    "addressedCount_other": "{{count}} 件対応済み"
  },
  "components": {
    "printButton": {
      "defaultLabel": "印刷"
    },
    "codeSearch": {
      "searchPlaceholder": "コードを検索...",
      "clearAriaLabel": "選択をクリア",
      "noCodesFound": "コードが見つかりません"
    },
    "demographicPicker": {
      "addPlaceholder": "追加…",
      "loading": "読み込み中…",
      "noneRecorded": "記録なし",
      "removeAriaLabel": "{{value}}を削除",
      "unavailable": "値リストを利用できません",
      "unavailableHint": "値リストを読み込めませんでした。既存の値は変更されず、保存されます。",
      "uncodedBadge": "コードなし",
      "uncodedTitle": "コード化された値の導入前に記録されました。削除はできますが、再追加はできません。"
    }
  },
  "pages": {
    "accessDenied": {
      "title": "アクセスが拒否されました",
      "httpStatus": "HTTP 403",
      "body": "このページを表示する権限がありません。",
      "attemptedLabel": "アクセス試行先：",
      "requiredPermissionLabel": "必要な権限：",
      "typicallyHeldByLabel": "通常この権限を保有する役割：",
      "signedInAs": "ログイン中のユーザー：",
      "contactAdminHelp": "これが誤りであるとお考えの場合は、システム管理者または部門責任者に連絡し、必要な役割の付与をご依頼ください。",
      "goBack": "戻る",
      "dashboard": "ダッシュボード",
      "contact": "問い合わせ"
    },
    "notificationInbox": {
      "title": "通知",
      "markAllRead": "すべて既読にする",
      "loading": "通知を読み込んでいます…",
      "errorState": "通知の読み込みに失敗しました。",
      "emptyState": "通知はありません。",
      "ariaFilterStatus": "ステータスで絞り込む",
      "ariaFilterPriority": "優先度で絞り込む",
      "ariaFilterType": "種類で絞り込む",
      "filterStatus": {
        "all": "すべて",
        "unread": "未読",
        "read": "既読"
      },
      "filterPriority": {
        "allLabel": "すべての優先度",
        "critical": "危急",
        "high": "高",
        "normal": "通常",
        "low": "低"
      },
      "filterType": {
        "allLabel": "すべての種類"
      },
      "notificationType": {
        "criticalResult": "危急値結果",
        "orderUpdate": "オーダー更新",
        "appointmentReminder": "予約リマインダー",
        "systemAlert": "システム通知",
        "cdsAlert": "臨床判断支援アラート",
        "result": "検査結果",
        "handoffAssigned": "引き継ぎ"
      },
      "toasts": {
        "allMarkedRead": "すべての通知を既読にしました",
        "markAllReadFailed": "通知の一括既読化に失敗しました",
        "markReadFailed": "通知の既読化に失敗しました"
      }
    },
    "entityResolver": {
      "invalidId": "リンクが無効です。",
      "notFound": "見つからないか、アクセス権限がありません。"
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "ライブ更新を利用できません",
    "body": "接続が復旧するまで、新しい結果やアラートは自動で届きません。",
    "authBody": "セッションの有効期限が切れました。ライブ更新を復旧するには再ログインしてください。",
    "retry": "再試行",
    "login": "ログイン"
  }
}
